var map = {
	"./google-play-badge-da-DK.svg": 56784,
	"./google-play-badge-de-DE.svg": 33090,
	"./google-play-badge-en-GB.svg": 9136,
	"./google-play-badge-en-US.svg": 53675,
	"./google-play-badge-es-ES.svg": 36908,
	"./google-play-badge-es-MX.svg": 90543,
	"./google-play-badge-fr-FR.svg": 71540,
	"./google-play-badge-it-IT.svg": 46346,
	"./google-play-badge-nb-NO.svg": 98473,
	"./google-play-badge-nl-NL.svg": 38928,
	"./google-play-badge-pl-PL.svg": 52040,
	"./google-play-badge-pt-BR.svg": 90356,
	"./google-play-badge-pt-PT.svg": 76792,
	"./google-play-badge-sv-SE.svg": 12121
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31724;